import { render, staticRenderFns } from "./uploadImg.component.vue?vue&type=template&id=53a9d343&scoped=true&"
import script from "./uploadImg.component.vue?vue&type=script&lang=js&"
export * from "./uploadImg.component.vue?vue&type=script&lang=js&"
import style0 from "./uploadImg.component.vue?vue&type=style&index=0&id=53a9d343&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a9d343",
  null
  
)

export default component.exports